import React from "react";
import "./MidwestDentalProgressTracker.scss";

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M16.6663 5.5L7.49967 14.6667L3.33301 10.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MidwestDentalProgressTracker = ({ steps, currentStep, deviceType }) => {
  // Mobile view - show step counter with current step name
  if (deviceType === "mobile") {
    // For entry page (currentStep is null), show Step 1 with first step name
    const isEntryPage = currentStep === null || currentStep === undefined;
    const isCompleted = !isEntryPage && currentStep >= steps.length;
    const displayStep = isEntryPage ? 1 : (isCompleted ? steps.length : currentStep + 1);
    const stepName = isEntryPage ? steps[0] : (steps[currentStep] || steps[steps.length - 1]);
    
    return (
      <div style={{ width: "100%", paddingTop: "12px", paddingBottom: "8px", paddingLeft: "16px", paddingRight: "16px", background: "white", justifyContent: "flex-start", alignItems: "center", gap: "8px", display: "inline-flex" }}>
        <div style={{ width: "31px", height: "33px", position: "relative", flexShrink: 0 }}>
            <div style={{ width: "31px", height: "31px", left: "0px", top: "2px", position: "absolute", background: isEntryPage ? "#8680A4" : isCompleted ? "#8680A4" : "#352B67", borderRadius: "9999px" }}></div>
            <div style={{ left: displayStep >= 10 ? "7px" : "12px", top: "5.50px", position: "absolute", color: "white", fontSize: "14px", fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', fontWeight: 500, lineHeight: "24px", wordWrap: "break-word" }}>{displayStep}</div>
        </div>
        <div style={{ flexDirection: "column", justifyContent: "center", alignItems: "flex-start", display: "inline-flex", flex: 1 }}>
            <div>
              <span style={{ color: "var(--Neutral-700, #616161)", fontSize: "10px", fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', fontWeight: 500, lineHeight: "16px", wordWrap: "break-word" }}>Step {displayStep}</span>
              <span style={{ color: "var(--Neutral-500, #9E9E9E)", fontSize: "10px", fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', fontWeight: 500, lineHeight: "16px", wordWrap: "break-word" }}>/{steps.length}</span>
            </div>
            <div style={{ color: "var(--Neutral-700, #616161)", fontSize: "14px", fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', fontWeight: 500, lineHeight: "24px", wordWrap: "break-word" }}>{stepName}</div>
        </div>
      </div>
    );
  }

  // Desktop/Tablet view - show progress circles
  return (
    <div className="midwest-dental-progress">
      <div className="midwest-dental-progress-steps">
        {steps.map((step, index) => {
          const isCompleted = currentStep !== null && currentStep !== undefined && index < currentStep;
          const isActive = currentStep !== null && currentStep !== undefined && index === currentStep;

          return (
            <div key={index} className="midwest-dental-progress-step">
              <div
                className={`midwest-dental-progress-circle ${
                  isCompleted ? "completed" : isActive ? "active" : "inactive"
                }`}
              >
                {isCompleted ? <CheckIcon /> : index + 1}
              </div>
              <span
                className={`midwest-dental-progress-label ${
                  isCompleted ? "completed" : isActive ? "active" : "inactive"
                }`}
              >
                {step}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MidwestDentalProgressTracker;
